import React, { useState } from "react";

const FormBuilderRadioElement = ({ field, buttonsColor }) => {
  const [radioClicked, setRadioClicked] = useState(null);

  const handleRadio = (radio, i) => {
    setRadioClicked(i);
  };
  const returnRadioChecked = (color) => {
    return (
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="5.5"
          cy="5.5"
          r="5"
          fill="white"
          stroke={`${
            color ? (color.includes("#") ? color : "#" + color) : "#15B4D4"
          }`}
        />
        <circle
          cx="5.5"
          cy="5.5"
          r="2.5"
          fill={`${
            color ? (color.includes("#") ? color : "#" + color) : "#15B4D4"
          }`}
        />
      </svg>
    );
  };

  const returnRadioUnChecked = (color) => {
    return (
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="5.5" cy="5.5" r="5" fill="white" stroke={`#C7CFD3`} />
      </svg>
    );
  };

  return (
    <div className="controls">
      {field.fields.radios.map((radio, i) => (
        <div
          tabIndex={0}
          key={i}
          className="radio-item"
          onClick={() => handleRadio(radio, i)}
        >
          <label>
            {radioClicked === i
              ? returnRadioChecked(buttonsColor)
              : returnRadioUnChecked(buttonsColor)}

            {radio}
          </label>
        </div>
      ))}
    </div>
  );
};

export default FormBuilderRadioElement;
